import React from 'react';

const ShieldIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.9974 1.99929L8.26006 1.38596C8.17706 1.35038 8.0877 1.33203 7.9974 1.33203C7.90709 1.33203 7.81773 1.35038 7.73473 1.38596L7.9974 1.99929ZM7.9974 13.9993L7.66673 14.578C7.76744 14.6355 7.88141 14.6657 7.9974 14.6657C8.11338 14.6657 8.22735 14.6355 8.32806 14.578L7.9974 13.9993ZM7.73473 1.38662L3.47206 3.21262L3.9974 4.43929L8.26006 2.61262L7.73473 1.38662ZM2.66406 4.43862V9.01196H3.9974V4.43862H2.66406ZM5.0154 13.0633L7.66673 14.578L8.32806 13.4206L5.67673 11.9053L5.0154 13.0633ZM8.32806 14.578L10.9794 13.0633L10.3181 11.9053L7.66673 13.4206L8.32806 14.578ZM13.3307 9.01129V4.43929H11.9974V9.01262L13.3307 9.01129ZM12.5227 3.21329L8.26006 1.38662L7.73473 2.61196L11.9974 4.43929L12.5227 3.21329ZM13.3307 4.43929C13.3307 4.1784 13.2541 3.92324 13.1105 3.70544C12.9669 3.48763 12.7625 3.31608 12.5227 3.21329L11.9974 4.43929H13.3307ZM10.9794 13.0633C11.6938 12.655 12.2876 12.0658 12.7005 11.3541C13.1135 10.6424 13.3309 9.83413 13.3307 9.01129H11.9974C11.9973 9.59895 11.8419 10.1761 11.5469 10.6844C11.2518 11.1926 10.8277 11.6138 10.3174 11.9053L10.9794 13.0633ZM2.66406 9.01129C2.66403 9.83402 2.88149 10.6421 3.29442 11.3537C3.70736 12.0653 4.30107 12.6551 5.0154 13.0633L5.67673 11.9053C5.16677 11.6138 4.74288 11.1928 4.44798 10.6848C4.15308 10.1769 3.99764 9.59999 3.9974 9.01262L2.66406 9.01129ZM3.47206 3.21262C3.23217 3.31546 3.02773 3.48711 2.8841 3.70505C2.74047 3.92298 2.66396 4.17828 2.66406 4.43929H3.9974L3.47206 3.21262Z'
        fill='currentColor'
      />
      <path
        d='M10 6.66602L7.33333 9.33268L6 7.99935'
        stroke='currentColor'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default ShieldIcon;
